import { render, staticRenderFns } from "./PublicShareSidebar.vue?vue&type=template&id=aeab8006&scoped=true"
import script from "./PublicShareSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareSidebar.vue?vue&type=script&lang=js"
import style0 from "./PublicShareSidebar.vue?vue&type=style&index=0&id=aeab8006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeab8006",
  null
  
)

export default component.exports